import { Grid, Card, CardContent, Box } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import DOMPurify from 'dompurify';
import React from 'react';

import Text from '~c/components/base/text';

interface TrainingVideo {
  title: string;
  iframe: string;
}

interface Props {
  className?: string;
}

const ResponsibleAITrainingVideosListImpl: React.FC<Props> = ({
  className,
}) => {
  const videos: TrainingVideo[] = [
    {
      title: 'AI Bias & Fairness Testing Training',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/4cbd19796b844886bea38983f8ca7c1e"
       title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
    {
      title: 'Microsoft Responsible AI Standard 2.0 Training',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/67a5cf7f25a44409ba5cc72e4722deda" 
            title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
    {
      title: 'NIST AI Risk Management Framework',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/a83e950ae3194e0b9c9c9a8aa7c2d624"
       title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
    {
      title: 'Diversity, Equity & Inclusion Training',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/0a5a7bbc04434787a15958be7d67bbc2"
       title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
    {
      title: 'Security Defence for AI Training',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/c5f39f4a2b2c405fb1e8ec9b4ed89e67"
       title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
    {
      title: 'Privacy for AI Training',
      iframe: `<iframe width="560" height="315" src="https://app.heygen.com/embeds/e66cc99ba6e54fbd82467e0d10f2ccde"
       title="HeyGen video player" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>`,
    },
  ];

  return (
    <Grid className={className} container spacing={3}>
      {videos?.map((video, index) => (
        <Grid item key={index}>
          <Card>
            <CardContent>
              <Text className="video-title" truncate>
                {video.title}
              </Text>
              <Box
                className="video-iframe-container"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(video.iframe, {
                    ALLOWED_TAGS: ['iframe'],
                    ALLOWED_ATTR: [
                      'width',
                      'height',
                      'src',
                      'title',
                      'frameborder',
                      'allow',
                      'allowfullscreen',
                    ],
                  }),
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export const ResponsibleAITrainingVideosList = muiStyled(
  ResponsibleAITrainingVideosListImpl
)(
  ({ theme }) => css`
    & .MuiCard-root {
      width: 352px;
    }
    & .video-title {
      -webkit-line-clamp: 1;
    }
    & .video-iframe-container {
      position: relative;
      padding-top: 56.25%;
      width: 100%;
      & iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  `
);

export default ResponsibleAITrainingVideosList;
